import { render, staticRenderFns } from "./ChooseMonthlyDeposit.vue?vue&type=template&id=3ddb7f67&scoped=true&"
import script from "./ChooseMonthlyDeposit.vue?vue&type=script&lang=js&"
export * from "./ChooseMonthlyDeposit.vue?vue&type=script&lang=js&"
import style0 from "./ChooseMonthlyDeposit.vue?vue&type=style&index=0&id=3ddb7f67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddb7f67",
  null
  
)

export default component.exports